import { render, staticRenderFns } from "./WebIntegrations.vue?vue&type=template&id=49d380ab"
import script from "./WebIntegrations.vue?vue&type=script&lang=js"
export * from "./WebIntegrations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports